import {
  setToken,
  //  getToken, deleteToken
} from "../../utils/token";

// Action Types
export const actionTypes = {
  DONE_SCHEDULE: "DONE_SCHEDULE",
  DONE_SCHEDULE_SUCCESS: "DONE_SCHEDULE_SUCCESS",
  DONE_SCHEDULE_FAILED: "DONE_SCHEDULE_FAILED",

  GET_COLD_LEAD: "GET_COLD_LEAD",
  GET_COLD_LEAD_SUCCESS: "GET_COLD_LEAD_SUCCESS",
  GET_COLD_LEAD_FAILED: "GET_COLD_LEAD_FAILED",

  GET_PRODUCTIVITY: "GET_PRODUCTIVITY",
  GET_PRODUCTIVITY_SUCCESS: "GET_PRODUCTIVITY_SUCCESS",
  GET_PRODUCTIVITY_FAILED: "GET_PRODUCTIVITY_FAILED",

  GET_RELEASED_COMMISSIONS: "GET_RELEASED_COMMISSIONS",
  GET_RELEASED_COMMISSIONS_SUCCESS: "GET_RELEASED_COMMISSIONS_SUCCESS",
  GET_RELEASED_COMMISSIONS_FAILED: "GET_RELEASED_COMMISSIONS_FAILED",

  GET_RECEIVABLE_COMMISSIONS: "GET_RECEIVABLE_COMMISSIONS",
  GET_RECEIVABLE_COMMISSIONS_SUCCESS: "GET_RECEIVABLE_COMMISSIONS_SUCCESS",
  GET_RECEIVABLE_COMMISSIONS_FAILED: "GET_RECEIVABLE_COMMISSIONS_FAILED",

  GET_QUALIFIED_COMMISSIONS: "GET_QUALIFIED_COMMISSIONS",
  GET_QUALIFIED_COMMISSIONS_SUCCESS: "GET_QUALIFIED_COMMISSIONS_SUCCESS",
  GET_QUALIFIED_COMMISSIONS_FAILED: "GET_QUALIFIED_COMMISSIONS_FAILED",

  GET_COMMISSIONS: "GET_COMMISSIONS",
  GET_COMMISSIONS_SUCCESS: "GET_COMMISSIONS_SUCCESS",
  GET_COMMISSIONS_FAILED: "GET_COMMISSIONS_FAILED",

  GET_SCHEDULES: "GET_SCHEDULES",
  GET_SCHEDULES_SUCCESS: "GET_SCHEDULES_SUCCESS",
  GET_SCHEDULES_FAILED: "GET_SCHEDULES_FAILED",

  CREATE_SCHEDULE: "CREATE_SCHEDULE",
  CREATE_SCHEDULE_SUCCESS: "CREATE_SCHEDULE_SUCCESS",
  CREATE_SCHEDULE_FAILED: "CREATE_SCHEDULE_FAILED",

  UPDATE_SCHEDULE: "UPDATE_SCHEDULE",
  UPDATE_SCHEDULE_SUCCESS: "UPDATE_SCHEDULE_SUCCESS",
  UPDATE_SCHEDULE_FAILED: "UPDATE_SCHEDULE_FAILED",

  DELETE_SCHEDULE: "DELETE_SCHEDULE",
  DELETE_SCHEDULE_SUCCESS: "DELETE_SCHEDULE_SUCCESS",
  DELETE_SCHEDULE_FAILED: "DELETE_SCHEDULE_FAILED",

  BUYER_SEARCH: "BUYER_SEARCH",
  BUYER_SEARCH_SUCCESS: "BUYER_SEARCH_SUCCESS",
  BUYER_SEARCH_FAILED: "BUYER_SEARCH_FAILED",

  SPOUSE_SEARCH: "SPOUSE_SEARCH",
  SPOUSE_SEARCH_SUCCESS: "SPOUSE_SEARCH_SUCCESS",
  SPOUSE_SEARCH_FAILED: "SPOUSE_SEARCH_FAILED",

  CO_BUYER_SEARCH: "CO_BUYER_SEARCH",
  CO_BUYER_SEARCH_SUCCESS: "CO_BUYER_SEARCH_SUCCESS",
  CO_BUYER_SEARCH_FAILED: "CO_BUYER_SEARCH_FAILED",

  POST_PERSONAL_INFORMATION: "POST_PERSONAL_INFORMATION",
  POST_PERSONAL_INFORMATION_SUCCESS: "POST_PERSONAL_INFORMATION_SUCCESS",
  POST_PERSONAL_INFORMATION_FAILED: "POST_PERSONAL_INFORMATION_FAILED",

  GET_USER_INFORMATION: "GET_USER_INFORMATION",
  GET_USER_INFORMATION_SUCCESS: "GET_USER_INFORMATION_SUCCESS",
  GET_USER_INFORMATION_FAILED: "GET_USER_INFORMATION_FALIED",

  POST_PURCHASE_JOURNEY: "POST_PURCHASE_JOURNEY",
  POST_PURCHASE_JOURNEY_SUCCESS: "POST_PURCHASE_JOURNEY_SUCCESS",
  POST_PURCHASE_JOURNEY_FAILED: "POST_PURCHASE_JOURNEY_FAILED",

  GET_PURCHASE_JOURNEY: "GET_PURCHASE_JOURNEY",
  GET_PURCHASE_JOURNEY_SUCCESS: "GET_PURCHASE_JOURNEY_SUCCESS",
  GET_PURCHASE_JOURNEY_FAILED: "GET_PURCHASE_JOURNEY_FAILED",

  POST_ATTACHMENT: "POST_ATTACHMENT",
  POST_ATTACHMENT_SUCCESS: "POST_ATTACHMENT_SUCCESS",
  POST_ATTACHMENT_FAILED: "POST_ATTACHMENT_FAILED",

  GET_ATTACHMENTS: "GET_ATTACHMENTS",
  GET_ATTACHMENTS_SUCCESS: "GET_ATTACHMENTS_SUCCESS",
  GET_ATTACHMENTS_FAILED: "GET_ATTACHMENTS_FAILED",

  POST_SIGNATURE: "POST_SIGNATURE",
  POST_SIGNATURE_SUCCESS: "POST_SIGNATURE_SUCCESS",
  POST_SIGNATURE_FAILED: "POST_SIGNATURE_FAILED",

  GET_USER_INFO_SAP: "GET_USER_SAP",
  GET_USER_INFO_SAP_SUCCESS: "GET_USER_SAP_SUCCESS",
  GET_USER_INFO_SAP_FAILED: "GET_USER_SAP_FAILED",

  GET_SIGNATURE: "GET_SIGNATURE",
  GET_SIGNATURE_SUCCESS: "GET_SIGNATURE_SUCCESS",
  GET_SIGNATURE_FAILED: "GET_SIGNATURE_FAILED",

  GET_RESERVATION_DETAIL: "GET_RESERVATION_DETAIL",
  GET_RESERVATION_DETAIL_SUCCESS: "GET_RESERVATION_DETAIL_SUCCESS",
  GET_RESERVATION_DETAIL_FAILED: "GET_RESERVATION_DETAIL_FAILED",

  GET_BOOKING_LIST: "GET_BOOKING_LIST",
  GET_BOOKING_LIST_SUCCESS: "GET_BOOKING_LIST_SUCCESS",
  GET_BOOKING_LIST_FAILED: "GET_BOOKING_LIST_FAILED",

  SUBMIT_BOOKING_STATUS: "SUBMIT_BOOKING_STATUS",
  SUBMIT_BOOKING_STATUS_SUCCESS: "SUBMIT_BOOKING_STATUS_SUCCESS",
  SUBMIT_BOOKING_STATUS_FAILED: "SUBMIT_BOOKING_STATUS_FAILED",

  GET_ALL_USER_INFO: "GET_ALL_USER_INFO",
  GET_ALL_USER_INFO_SUCCESS: "GET_ALL_USER_INFO_SUCCESS",
  GET_ALL_USER_INFO_FAILED: "GET_ALL_USER_INFO_FAILED",

  POST_LEAD: "POST_LEAD",
  POST_LEAD_SUCCESS: "POST_LEAD_SUCCESS",
  POST_LEAD_FAILED: "POST_LEAD_FAILED",

  GET_BRANDS: "GET_BRANDS",
  GET_BRANDS_SUCCESS: "GET_BRANDS_SUCCESS",
  GET_BRANDS_FAILED: "GET_BRANDS_FAILED",

  GET_LEAD: "GET_LEAD",
  GET_LEAD_SUCCESS: "GET_LEAD_SUCCESS",
  GET_LEAD_FAILED: "GET_LEAD_FAILED",

  GET_BUYER_HISTORY: "GET_BUYER_HISTORY",
  GET_BUYER_HISTORY_SUCCESS: "GET_BUYER_HISTORY_SUCCESS",
  GET_BUYER_HISTORY_FAILED: "GET_BUYER_HISTORY_FAILED",

  GET_LEAD_PROFILE: "GET_LEAD_PROFILE",
  GET_LEAD_PROFILE_SUCCESS: "GET_LEAD_PROFILE_SUCCESS",
  GET_LEAD_PROFILE_FAILED: "GET_LEAD_PROFILE_FAILED",

  POST_OBSERVATION: "POST_OBSERVATION",
  POST_OBSERVATION_SUCCESS: "POST_OBSERVATION_SUCCESS",
  POST_OBSERVATION_FAILED: "POST_OBSERVATION_FAILED",

  GET_SAP_BOOKING_LIST: "GET_SAP_BOOKING_LIST",
  GET_SAP_BOOKING_LIST_SUCCESS: "GET_SAP_BOOKING_LIST_SUCCESS",
  GET_SAP_BOOKING_LIST_FAILED: "GET_SAP_BOOKING_LIST_FAILED",

  GET_SELLER_GROUP: "GET_SELLER_GROUP",
  GET_SELLER_GROUP_SUCCESS: "GET_SELLER_GROUP_SUCCESS",
  GET_SELLER_GROUP_FAILED: "GET_SELLER_GROUP_FAILED",

  GET_TRANSFER_REQUEST: "GET_TRANSFER_REQUEST",
  GET_TRANSFER_REQUEST_SUCCESS: "GET_TRANSFER_REQUEST_SUCCESS",
  GET_TRANSFER_REQUEST_FAILED: "GET_TRANSFER_REQUEST_FAILED",

  POST_TRANSFER_REQUEST: "POST_TRANSFER_REQUEST",
  POST_TRANSFER_REQUEST_SUCCESS: "POST_TRANSFER_REQUEST_SUCCESS",
  POST_TRANSFER_REQUEST_FAILED: "POST_TRANSFER_REQUEST_FAILED",

  GET_NATIONALITY: "GET_NATIONALITY",
  GET_NATIONALITY_SUCCESS: "GET_NATIONALITY_SUCCESS",
  GET_NATIONALITY_FAILED: "GET_NATIONALITY_FAILED",

  POST_LEAD_SIGNATURE: "POST_LEAD_SIGNATURE",
  POST_LEAD_SIGNATURE_SUCCESS: "POST_LEAD_SIGNATURE_SUCCESS",
  POST_LEAD_SIGNATURE_FAILED: "POST_LEAD_SIGNATURE_FAILED",

  GET_LEAD_BUYER_LIST: "GET_LEAD_BUYER_LIST",
  GET_LEAD_BUYER_LIST_SUCCESS: "GET_LEAD_BUYER_LIST_SUCCESS",
  GET_LEAD_BUYER_LIST_FAILED: "GET_LEAD_BUYER_LIST_FAILED",

  GET_RETENTION: "GET_RETENTION",
  GET_RETENTION_SUCCESS: "GET_RETENTION_SUCCESS",
  GET_RETENTION_FAILED: "GET_RETENTION_FAILED",

  POST_OWNERSHIP: "POST_OWNERSHIP",
  POST_OWNERSHIP_SUCCESS: "POST_OWNERSHIP_SUCCESS",
  POST_OWNERSHIP_FAILED: "POST_OWNERSHIP_FAILED",

  POST_REQUEST_OWNERSHIP_EXTENSION: "POST_REQUEST_OWNERSHIP_EXTENSION",
  POST_REQUEST_OWNERSHIP_EXTENSION_SUCCESS:
    "POST_REQUEST_OWNERSHIP_EXTENSION_SUCCESS",
  POST_REQUEST_OWNERSHIP_EXTENSION_FAILED:
    "POST_REQUEST_OWNERSHIP_EXTENSION_FAILED",

  POST_REQUEST_SUBMISSION_EXTENSION: "POST_REQUEST_SUBMISSION_EXTENSION",
  POST_REQUEST_SUBMISSION_EXTENSION_SUCCESS:
    "POST_REQUEST_SUBMISSION_EXTENSION_SUCCESS",
  POST_REQUEST_SUBMISSION_EXTENSION_FAILED:
    "POST_REQUEST_SUBMISSION_EXTENSION_FAILED",

  GET_LEAD_RENEWAL: "GET_LEAD_RENEWAL",
  GET_LEAD_RENEWAL_SUCCESS: "GET_LEAD_RENEWAL_SUCCESS",
  GET_LEAD_RENEWAL_FAILED: "GET_LEAD_RENEWAL_FAILED",

  POST_LEAD_RENEWAL: "POST_LEAD_RENEWAL",
  POST_LEAD_RENEWAL_SUCCESS: "POST_LEAD_RENEWAL_SUCCESS",
  POST_LEAD_RENEWAL_FAILED: "POST_LEAD_RENEWAL_FAILED",

  POST_E_PAYMENT: "POST_E_PAYMENT",
  POST_E_PAYMENT_SUCCESS: "POST_E_PAYMENT_SUCCESS",
  POST_E_PAYMENT_FAILED: "POST_E_PAYMENT_FAILED",

  GET_DATA_MONITORING: "GET_DATA_MONITORING",
  GET_DATA_MONITORING_SUCCESS: "GET_DATA_MONITORING_SUCCESS",
  GET_DATA_MONITORING_FAILED: "GET_DATA_MONITORING_FAILED",
};

// Action creators
export const actionCreators = {
  markAsDone: (params) => ({
    type: actionTypes.DONE_SCHEDULE,
    params,
  }),
  getDataMonitoring: (params) => ({
    type: actionTypes.GET_DATA_MONITORING,
    params,
  }),
  getColdLead: (params) => ({
    type: actionTypes.GET_COLD_LEAD,
    params,
  }),
  getProductivity: (params) => ({
    type: actionTypes.GET_PRODUCTIVITY,
    params,
  }),
  getCommissions: (params) => ({
    type: actionTypes.GET_COMMISSIONS,
    params,
  }),
  getReleasedCommissions: (params) => ({
    type: actionTypes.GET_RELEASED_COMMISSIONS,
    params,
  }),
  getReceivableCommissions: (params) => ({
    type: actionTypes.GET_RECEIVABLE_COMMISSIONS,
    params,
  }),
  getQualifiedCommissions: (params) => ({
    type: actionTypes.GET_QUALIFIED_COMMISSIONS,
    params,
  }),
  getSchedules: (params) => ({
    type: actionTypes.GET_SCHEDULES,
    params,
  }),
  createSchedule: (params, onSuccess, onFailed) => ({
    type: actionTypes.CREATE_SCHEDULE,
    params,
    onSuccess,
    onFailed,
  }),
  updateSchedule: (params, onSuccess, onFailed) => ({
    type: actionTypes.UPDATE_SCHEDULE,
    params,
    onSuccess,
    onFailed,
  }),
  deleteSchedule: (params, onSuccess, onFailed) => ({
    type: actionTypes.DELETE_SCHEDULE,
    params,
    onSuccess,
    onFailed,
  }),
  searchBuyer: (params) => ({
    type: actionTypes.BUYER_SEARCH,
    params,
  }),
  searchSpouse: (params) => ({
    type: actionTypes.SPOUSE_SEARCH,
    params,
  }),
  searchCoBuyer: (params) => ({
    type: actionTypes.CO_BUYER_SEARCH,
    params,
  }),
  postBuyerInformation: (params) => ({
    type: actionTypes.POST_PERSONAL_INFORMATION,
    params,
  }),
  getUserInformation: (params) => ({
    type: actionTypes.GET_USER_INFORMATION,
    params,
  }),
  postClientSurvey: (params) => ({
    type: actionTypes.POST_PURCHASE_JOURNEY,
    params,
  }),
  getClientSurvey: (params) => ({
    type: actionTypes.GET_PURCHASE_JOURNEY,
    params,
  }),
  postClientAttachment: (params) => ({
    type: actionTypes.POST_ATTACHMENT,
    params,
  }),
  getAttachments: (params) => ({
    type: actionTypes.GET_ATTACHMENTS,
    params,
  }),
  postClientSignature: (params) => ({
    type: actionTypes.POST_SIGNATURE,
    params,
  }),
  getUserInfoSap: (params) => ({
    type: actionTypes.GET_USER_INFO_SAP,
    params,
  }),
  getClientSignature: (params) => ({
    type: actionTypes.GET_SIGNATURE,
    params,
  }),
  getReservationDetails: (params) => ({
    type: actionTypes.GET_RESERVATION_DETAIL,
    params,
  }),
  getBookingList: (params) => ({
    type: actionTypes.GET_BOOKING_LIST,
    params,
  }),
  submitBookingStatus: (params) => ({
    type: actionTypes.SUBMIT_BOOKING_STATUS,
    params,
  }),
  getAllUserInfo: (params) => ({
    type: actionTypes.GET_ALL_USER_INFO,
    params,
  }),
  postLeadForm: (params) => ({
    type: actionTypes.POST_LEAD,
    params,
  }),
  getBrands: (params) => ({
    type: actionTypes.GET_BRANDS,
    params,
  }),
  getLead: () => ({
    type: actionTypes.GET_LEAD,
  }),
  getBuyerHistory: () => ({
    type: actionTypes.GET_BUYER_HISTORY,
  }),
  getLeadProfile: (params) => ({
    type: actionTypes.GET_LEAD_PROFILE,
    params,
  }),
  createObservation: (params) => ({
    type: actionTypes.POST_OBSERVATION,
    params,
  }),
  getSapBookingList: (params) => ({
    type: actionTypes.GET_SAP_BOOKING_LIST,
    params,
  }),
  getTransferRequest: () => ({
    type: actionTypes.GET_TRANSFER_REQUEST,
  }),
  getSellerGroup: () => ({
    type: actionTypes.GET_SELLER_GROUP,
  }),
  postTransferRequest: (params) => ({
    type: actionTypes.POST_TRANSFER_REQUEST,
    params,
  }),
  getNationality: (params) => ({
    type: actionTypes.GET_NATIONALITY,
    params,
  }),
  postLeadSignature: (params) => ({
    type: actionTypes.POST_LEAD_SIGNATURE,
    params,
  }),
  getLeadBuyer: (params) => ({
    type: actionTypes.GET_LEAD_BUYER_LIST,
    params,
  }),
  getRetention: (params) => ({
    type: actionTypes.GET_RETENTION,
    params,
  }),
  postClaimOwnership: (params) => ({
    type: actionTypes.POST_OWNERSHIP,
    params,
  }),

  postRequestOwnershipExtension: (params) => ({
    type: actionTypes.POST_REQUEST_OWNERSHIP_EXTENSION,
    params,
  }),
  postRequestSubmissionExtension: (params) => ({
    type: actionTypes.POST_REQUEST_SUBMISSION_EXTENSION,
    params,
  }),
  getLeadRenewal: (params) => ({
    type: actionTypes.GET_LEAD_RENEWAL,
    params,
  }),
  postLeadRenewal: (params) => ({
    type: actionTypes.POST_LEAD_RENEWAL,
    params,
  }),
  postEPayment: (params) => ({
    type: actionTypes.POST_E_PAYMENT,
    params,
  }),
};

// Reducer
const initialState = {
  isMarkingDone: false,
  isDoneData: [],

  isPostingLead: false,
  coldLeadData: [],
  isGettingColdLead: false,
  dataMonitoring: [],
  isGettingDataMonitoring: false,
  productivity: null,
  productivityLoading: false,
  releasedCommissions: [],
  releasedCommissionsLoading: false,
  receivableCommissions: [],
  receivableCommissionsLoading: false,
  qualifiedCommissions: null,
  qualifiedCommissionsLoading: false,
  schedules: [],
  schedulesLoading: false,

  meta: null,
  isLoading: false,
  error: null,
  buyerResult: [],
  spouseResult: [],
  coBuyerResult: [],
  successFormSubmit: false,
  userFormData: null,
  surveyResult: null,
  surveyData: null,
  successAttachment: false,
  attachmentData: [],
  clientSignatures: [],
  reservationDetails: null,
  bookingList: [],
  isBookingSubmitted: false,
  isStatusSending: false,
  successSignature: false,
  buyerAlertFound: false,
  spouseAlertFound: false,
  coBuyerAlertFound: false,
  allUserInfo: [],

  isLeadLoading: false,
  brandList: [],
  leadData: [],
  leadProfile: null,
  isLeadProfileLoading: false,
  observationLoading: false,
  sapBookingList: [],
  isSapBookingLoading: false,
  transferRequestList: [],
  sellerGroupList: [],
  isTransferLoading: false,
  nationality: [],
  leadDataResult: null,
  isPostLeadSignature: false,
  retention: [],

  claimOwnership: false,
  isLoadingBookingList: false,
  leadRenewal: [],
  ePayment: null,
  isLoadingEPayment: false,

  buyerHistoryResult: [],
  isGettingBuyerHistory: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DONE_SCHEDULE:
      return Object.assign({}, state, {
        isMarkingDone: true,
        error: null,
      });

    case actionTypes.DONE_SCHEDULE_SUCCESS:
      return Object.assign({}, state, {
        isDoneData: action.payload,
        isMarkingDone: false,
        error: null,
      });

    case actionTypes.DONE_SCHEDULE_FAILED:
      return Object.assign({}, state, {
        isDoneData: [],
        isMarkingDone: false,
        error: action.error,
      });

    case actionTypes.GET_COLD_LEAD:
      return Object.assign({}, state, {
        coldLeadData: [],
        isGettingColdLead: true,
        error: null,
      });

    case actionTypes.GET_COLD_LEAD_SUCCESS:
      return Object.assign({}, state, {
        coldLeadData: action.payload,
        isGettingColdLead: false,
        error: null,
      });

    case actionTypes.GET_COLD_LEAD_FAILED:
      return Object.assign({}, state, {
        coldLeadData: [],
        isGettingColdLead: false,
        error: action.error,
      });

    case actionTypes.GET_DATA_MONITORING:
      return Object.assign({}, state, {
        dataMonitoring: [],
        isGettingDataMonitoring: true,
        error: null,
      });

    case actionTypes.GET_DATA_MONITORING_SUCCESS:
      return Object.assign({}, state, {
        dataMonitoring: action.payload,
        isGettingDataMonitoring: false,
        error: null,
      });

    case actionTypes.GET_DATA_MONITORING_FAILED:
      return Object.assign({}, state, {
        dataMonitoring: [],
        isGettingDataMonitoring: false,
        error: action.error,
      });

    case actionTypes.POST_OWNERSHIP:
      return Object.assign({}, state, {
        claimOwnership: true,
        error: null,
      });

    case actionTypes.POST_OWNERSHIP_SUCCESS:
      return Object.assign({}, state, {
        claimOwnership: false,
        error: null,
      });

    case actionTypes.POST_OWNERSHIP_FAILED:
      return Object.assign({}, state, {
        claimOwnership: false,
        error: action.error,
      });

    case actionTypes.GET_RETENTION:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        retention: [],
      });

    case actionTypes.GET_RETENTION_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        retention: action.payload,
      });

    case actionTypes.GET_RETENTION_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        retention: [],
      });

    case actionTypes.GET_NATIONALITY:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        nationality: [],
      });

    case actionTypes.GET_NATIONALITY_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        nationality: action.payload,
      });

    case actionTypes.GET_NATIONALITY_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        nationality: [],
      });

    case actionTypes.GET_TRANSFER_REQUEST:
      return Object.assign({}, state, {
        isTransferLoading: true,
        error: null,
        transferRequestList: [],
      });

    case actionTypes.GET_TRANSFER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        isTransferLoading: false,
        error: null,
        transferRequestList: action.payload,
      });

    case actionTypes.GET_TRANSFER_REQUEST_FAILED:
      return Object.assign({}, state, {
        isTransferLoading: false,
        error: action.error,
        transferRequestList: [],
      });

    case actionTypes.POST_TRANSFER_REQUEST:
      return Object.assign({}, state, {
        isTransferLoading: true,
        error: null,
      });

    case actionTypes.POST_TRANSFER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        isTransferLoading: false,
        error: null,
      });

    case actionTypes.POST_TRANSFER_REQUEST_FAILED:
      return Object.assign({}, state, {
        isTransferLoading: false,
        error: action.error,
      });

    case actionTypes.GET_SELLER_GROUP:
      return Object.assign({}, state, {
        isTransferLoading: true,
        error: null,
      });

    case actionTypes.GET_SELLER_GROUP_SUCCESS:
      return Object.assign({}, state, {
        isTransferLoading: false,
        error: null,
        sellerGroupList: action.payload,
      });

    case actionTypes.GET_SELLER_GROUP_FAILED:
      return Object.assign({}, state, {
        isTransferLoading: false,
        error: action.error,
      });

    case actionTypes.GET_SAP_BOOKING_LIST:
      return Object.assign({}, state, {
        isSapBookingLoading: true,
        error: null,
        sapBookingList: [],
      });

    case actionTypes.GET_SAP_BOOKING_LIST_SUCCESS:
      return Object.assign({}, state, {
        isSapBookingLoading: false,
        error: null,
        sapBookingList: action.payload,
      });

    case actionTypes.GET_SAP_BOOKING_LIST_FAILED:
      return Object.assign({}, state, {
        isSapBookingLoading: false,
        error: action.error,
        sapBookingList: [],
      });

    case actionTypes.POST_OBSERVATION:
      return Object.assign({}, state, {
        observationLoading: true,
        error: null,
      });

    case actionTypes.POST_OBSERVATION_SUCCESS:
      return Object.assign({}, state, {
        observationLoading: false,
        error: null,
      });

    case actionTypes.POST_OBSERVATION_FAILED:
      return Object.assign({}, state, {
        observationLoading: false,
        error: action.error,
      });

    case actionTypes.GET_LEAD:
      return Object.assign({}, state, {
        isLeadLoading: true,
        error: null,
        leadData: [],
      });

    case actionTypes.GET_LEAD_SUCCESS:
      return Object.assign({}, state, {
        isLeadLoading: false,
        error: null,
        leadData: action.payload,
      });

    case actionTypes.GET_LEAD_FAILED:
      return Object.assign({}, state, {
        isLeadLoading: false,
        error: action.error,
        leadData: [],
      });
    //GET BUYER HISTORY
    case actionTypes.GET_BUYER_HISTORY:
      return Object.assign({}, state, {
        error: null,
        isGettingBuyerHistory: true,
        buyerHistoryResult: [],
      });

    case actionTypes.GET_BUYER_HISTORY_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        isGettingBuyerHistory: false,
        buyerHistoryResult: action.payload,
      });

    case actionTypes.GET_BUYER_HISTORY_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isGettingBuyerHistory: false,
        buyerHistoryResult: [],
      });
    case actionTypes.GET_LEAD_BUYER_LIST:
      return Object.assign({}, state, {
        isLeadLoading: true,
        error: null,
        leadData: [],
      });

    case actionTypes.GET_LEAD_BUYER_LIST_SUCCESS:
      return Object.assign({}, state, {
        isLeadLoading: false,
        error: null,
        leadData: action.payload,
      });

    case actionTypes.GET_LEAD_BUYER_LIST_FAILED:
      return Object.assign({}, state, {
        isLeadLoading: false,
        error: action.error,
        leadData: [],
      });

    case actionTypes.GET_LEAD_PROFILE:
      return Object.assign({}, state, {
        isLeadProfileLoading: true,
        error: null,
        leadProfile: null,
      });

    case actionTypes.GET_LEAD_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        isLeadProfileLoading: false,
        error: null,
        leadProfile:
          Object.keys(action.payload).length > 0 ? action.payload : null,
      });

    case actionTypes.GET_LEAD_PROFILE_FAILED:
      return Object.assign({}, state, {
        isLeadProfileLoading: false,
        error: action.error,
        leadProfile: null,
      });

    case actionTypes.GET_BRANDS:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
      });

    case actionTypes.GET_BRANDS_SUCCESS:
      return Object.assign({}, state, {
        isLeadLoading: false,
        error: null,
        brandList: action.payload,
      });

    case actionTypes.GET_BRANDS_FAILED:
      return Object.assign({}, state, {
        isLeadLoading: false,
        error: action.error,
        brandList: [],
      });

    case actionTypes.POST_LEAD:
      return Object.assign({}, state, {
        isLeadLoading: true,
        isPostingLead: true,
        error: null,
        leadDataResult: null,
      });

    case actionTypes.POST_LEAD_SUCCESS:
      return Object.assign({}, state, {
        isLeadLoading: false,
        error: null,
        isPostingLead: false,
        leadDataResult: action.payload,
      });

    case actionTypes.POST_LEAD_FAILED:
      return Object.assign({}, state, {
        isLeadLoading: false,
        error: action.error,
        isPostingLead: false,
        leadDataResult: null,
      });

    case actionTypes.GET_ALL_USER_INFO:
      return Object.assign({}, state, {
        isStatusSending: true,
        error: null,
        allUserInfo: [],
      });

    case actionTypes.GET_ALL_USER_INFO_SUCCESS:
      return Object.assign({}, state, {
        isStatusSending: false,
        error: null,
        allUserInfo: action.payload,
      });

    case actionTypes.GET_ALL_USER_INFO_FAILED:
      return Object.assign({}, state, {
        isStatusSending: false,
        error: action.error,
        allUserInfo: [],
      });

    case actionTypes.SUBMIT_BOOKING_STATUS:
      return Object.assign({}, state, {
        isStatusSending: true,
        error: null,
        isBookingSubmitted: false,
      });

    case actionTypes.SUBMIT_BOOKING_STATUS_SUCCESS:
      return Object.assign({}, state, {
        isStatusSending: false,
        error: null,
        isBookingSubmitted: true,
      });

    case actionTypes.SUBMIT_BOOKING_STATUS_FAILED:
      return Object.assign({}, state, {
        isStatusSending: false,
        error: action.error,
        isBookingSubmitted: false,
      });

    case actionTypes.GET_BOOKING_LIST:
      return Object.assign({}, state, {
        isLoadingBookingList: true,
        error: null,
        bookingList: [],
      });

    case actionTypes.GET_BOOKING_LIST_SUCCESS:
      return Object.assign({}, state, {
        isLoadingBookingList: false,
        error: null,
        bookingList: action.payload,
      });

    case actionTypes.GET_BOOKING_LIST_FAILED:
      return Object.assign({}, state, {
        isLoadingBookingList: false,
        error: action.error,
        bookingList: [],
      });

    case actionTypes.GET_USER_INFO_SAP:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        userFormData: null,
      });

    case actionTypes.GET_USER_INFO_SAP_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        userFormData: action.payload,
      });

    case actionTypes.GET_USER_INFO_SAP_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        userFormData: null,
      });

    case actionTypes.GET_RESERVATION_DETAIL:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        reservationDetails: null,
      });

    case actionTypes.GET_RESERVATION_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        reservationDetails: action.payload,
      });

    case actionTypes.GET_RESERVATION_DETAIL_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        reservationDetails: null,
      });

    case actionTypes.GET_SIGNATURE:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        clientSignatures: [],
      });

    case actionTypes.GET_SIGNATURE_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        clientSignatures: action.payload,
      });

    case actionTypes.GET_SIGNATURE_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        clientSignatures: [],
      });

    case actionTypes.POST_SIGNATURE:
      return Object.assign({}, state, {
        isLoading: true,
        successSignature: false,
        error: null,
      });

    case actionTypes.POST_SIGNATURE_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        successSignature: true,
        error: null,
      });

    case actionTypes.POST_SIGNATURE_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        successSignature: false,
      });

    case actionTypes.GET_ATTACHMENTS:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        attachmentData: [],
      });

    case actionTypes.GET_ATTACHMENTS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        attachmentData: action.payload,
      });

    case actionTypes.GET_ATTACHMENTS_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        attachmentData: [],
      });

    case actionTypes.POST_ATTACHMENT:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        successAttachment: false,
      });

    case actionTypes.POST_ATTACHMENT_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        successAttachment: true,
      });

    case actionTypes.POST_ATTACHMENT_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        successAttachment: false,
      });

    case actionTypes.CREATE_SCHEDULE:
      return Object.assign({}, state, {
        error: null,
      });

    case actionTypes.CREATE_SCHEDULE_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        schedules: state.schedules.concat([action.payload]),
      });

    case actionTypes.CREATE_SCHEDULE_FAILED:
      return Object.assign({}, state, {
        error: action.error,
      });

    case actionTypes.UPDATE_SCHEDULE:
      return Object.assign({}, state, {
        error: null,
      });

    case actionTypes.UPDATE_SCHEDULE_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        schedules: state.schedules.map((schedule) =>
          schedule.id === action.scheduleId
            ? {
                ...schedule,
                start_date: action.payload.start_date,
                end_date: action.payload.end_date,
                name: action.payload.name,
                notes: action.payload.notes,
                purpose: action.payload.purpose,
                // notify_date: action.payload.notify_date,
              }
            : schedule
        ),
      });

    case actionTypes.UPDATE_SCHEDULE_FAILED:
      return Object.assign({}, state, {
        error: action.error,
      });

    case actionTypes.DELETE_SCHEDULE:
      return Object.assign({}, state, {
        error: null,
      });

    case actionTypes.DELETE_SCHEDULE_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        schedules: state.schedules.filter(
          (schedule) => schedule.id !== action.scheduleId
        ),
      });

    case actionTypes.DELETE_SCHEDULE_FAILED:
      return Object.assign({}, state, {
        error: action.error,
      });

    case actionTypes.GET_SCHEDULES:
      return Object.assign({}, state, {
        schedulesLoading: true,
        error: null,
        schedules: [],
      });

    case actionTypes.GET_SCHEDULES_SUCCESS:
      return Object.assign({}, state, {
        schedulesLoading: false,
        error: null,
        schedules: action.payload,
      });

    case actionTypes.GET_SCHEDULES_FAILED:
      return Object.assign({}, state, {
        schedulesLoading: false,
        error: action.error,
        schedules: [],
      });

    case actionTypes.GET_COMMISSIONS:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        releasedCommissions: [],
        receivableCommissions: [],
        qualifiedCommissions: null,
      });

    case actionTypes.GET_RELEASED_COMMISSIONS:
      return Object.assign({}, state, {
        releasedCommissionsLoading: true,
        error: null,
        releasedCommissions: [],
      });

    case actionTypes.GET_RECEIVABLE_COMMISSIONS:
      return Object.assign({}, state, {
        receivableCommissionsLoading: true,
        error: null,
        receivableCommissions: [],
      });

    case actionTypes.GET_QUALIFIED_COMMISSIONS:
      return Object.assign({}, state, {
        qualifiedCommissionsLoading: true,
        error: null,
        qualifiedCommissions: null,
      });

    case actionTypes.GET_PRODUCTIVITY:
      return Object.assign({}, state, {
        productivityLoading: true,
        error: null,
        productivity: null,
      });

    case actionTypes.BUYER_SEARCH:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        buyerResult: [],
        buyerAlertFound: false,
      });

    case actionTypes.POST_PERSONAL_INFORMATION:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        successFormSubmit: false,
      });

    case actionTypes.SPOUSE_SEARCH:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        spouseResult: [],
        spouseAlertFound: false,
      });

    case actionTypes.CO_BUYER_SEARCH:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        coBuyerResult: [],
        coBuyerAlertFound: false,
      });

    case actionTypes.GET_USER_INFORMATION:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        userFormData: null,
      });

    case actionTypes.POST_PURCHASE_JOURNEY:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        surveyResult: null,
      });

    case actionTypes.GET_PURCHASE_JOURNEY:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        surveyData: null,
      });

    case actionTypes.POST_PURCHASE_JOURNEY_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        surveyResult: action.payload,
      });

    case actionTypes.GET_PURCHASE_JOURNEY_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        surveyData: action.payload,
      });

    case actionTypes.GET_USER_INFORMATION_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        userFormData: action.payload,
      });

    case actionTypes.BUYER_SEARCH_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        buyerResult: action.payload,
        buyerAlertFound: true,
      });

    case actionTypes.SPOUSE_SEARCH_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        spouseResult: action.payload,
        spouseAlertFound: true,
      });

    case actionTypes.CO_BUYER_SEARCH_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        coBuyerResult: action.payload,
        coBuyerAlertFound: true,
      });

    case actionTypes.POST_PERSONAL_INFORMATION_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        successFormSubmit: true,
      });

    case actionTypes.GET_PRODUCTIVITY_SUCCESS:
      return Object.assign({}, state, {
        productivityLoading: false,
        error: null,
        productivity: action.payload,
      });

    case actionTypes.GET_RELEASED_COMMISSIONS_SUCCESS:
      return Object.assign({}, state, {
        releasedCommissionsLoading: false,
        error: null,
        releasedCommissions: action.payload,
      });

    case actionTypes.GET_RECEIVABLE_COMMISSIONS_SUCCESS:
      return Object.assign({}, state, {
        receivableCommissionsLoading: false,
        error: null,
        receivableCommissions: action.payload,
      });

    case actionTypes.GET_QUALIFIED_COMMISSIONS_SUCCESS:
      return Object.assign({}, state, {
        qualifiedCommissionsLoading: false,
        error: null,
        qualifiedCommissions: action.payload,
      });

    case actionTypes.GET_COMMISSIONS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        releasedCommissions: action.releasedCommissions,
        receivableCommissions: action.receivableCommissions,
        qualifiedCommissions: action.qualifiedCommissions,
      });

    case actionTypes.GET_PURCHASE_JOURNEY_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        surveyData: null,
      });

    case actionTypes.GET_USER_INFORMATION_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        userFormData: null,
      });

    case actionTypes.POST_PURCHASE_JOURNEY_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        surveyResult: null,
      });

    case actionTypes.GET_COMMISSIONS_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        releasedCommissions: [],
        receivableCommissions: [],
        qualifiedCommissions: null,
      });

    case actionTypes.POST_PERSONAL_INFORMATION_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        successFormSubmit: false,
      });

    case actionTypes.BUYER_SEARCH_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        buyerResult: [],
        buyerAlertFound: false,
      });

    case actionTypes.SPOUSE_SEARCH_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        spouseResult: [],
        spouseAlertFound: false,
      });

    case actionTypes.CO_BUYER_SEARCH_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        coBuyerResult: [],
        coBuyerAlertFound: false,
      });

    case actionTypes.GET_PRODUCTIVITY_FAILED:
      return Object.assign({}, state, {
        productivityLoading: false,
        error: action.error,
      });

    case actionTypes.GET_RELEASED_COMMISSIONS_FAILED:
      return Object.assign({}, state, {
        releasedCommissionsLoading: false,
        error: action.error,
      });

    case actionTypes.GET_RECEIVABLE_COMMISSIONS_FAILED:
      return Object.assign({}, state, {
        receivableCommissionsLoading: false,
        error: action.error,
      });

    case actionTypes.GET_QUALIFIED_COMMISSIONS_FAILED:
      return Object.assign({}, state, {
        qualifiedCommissionsLoading: false,
        error: action.error,
      });

    case actionTypes.POST_REQUEST_OWNERSHIP_EXTENSION:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
      });

    case actionTypes.POST_REQUEST_OWNERSHIP_EXTENSION_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
      });

    case actionTypes.POST_REQUEST_OWNERSHIP_EXTENSION_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
      });

    case actionTypes.POST_REQUEST_SUBMISSION_EXTENSION:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
      });

    case actionTypes.POST_REQUEST_SUBMISSION_EXTENSION_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
      });

    case actionTypes.POST_REQUEST_SUBMISSION_EXTENSION_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
      });

    case actionTypes.GET_LEAD_RENEWAL:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        leadRenewal: [],
      });

    case actionTypes.GET_LEAD_RENEWAL_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        leadRenewal: action.payload,
      });

    case actionTypes.GET_LEAD_RENEWAL_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        leadRenewal: [],
      });

    case actionTypes.POST_LEAD_RENEWAL:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
      });

    case actionTypes.POST_LEAD_RENEWAL_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
      });

    case actionTypes.POST_LEAD_RENEWAL_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
      });

    case actionTypes.POST_E_PAYMENT:
      return Object.assign({}, state, {
        ePayment: null,
        isLoadingEPayment: true,
        error: null,
      });

    case actionTypes.POST_E_PAYMENT_SUCCESS:
      return Object.assign({}, state, {
        isLoadingEPayment: false,
        error: null,
        ePayment: action.payload,
      });

    case actionTypes.POST_E_PAYMENT_FAILED:
      return Object.assign({}, state, {
        isLoadingEPayment: false,
        error: action.error,
      });

    default:
      return state;
  }
};
